export const annuityUserNameContainerClasses = `
    flex
    gap-4
`
